/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from "./router";
import cookies from "vue-cookies";
Vue.config.productionTip = false;
Vue.prototype.$cookies = cookies;
import axios from "axios";
import Icon from 'vue2-svg-icon/Icon.vue';
import "./assets/font_icon/iconfont.css";
import { visible } from '@/directives/intersectionObserver.js';
// 示例：设置cookie
// this.$cookies.set('tokenCode', 'cookie_value')
// 示例：获取cookie
// let cookieValue = this.$cookies.get('cookie_name')
// 示例：删除cookie
// this.$cookies.remove('cookie_name')
axios.interceptors.request.use(
  function (config) {
    // config.headers["tokenCode"] = $cookies.get("tokenCode");
    config.headers["token"] = $cookies.get("token");
    return config;
  },
  function () {
    return Promise.reject(error);
  }
);

router.beforeEach((to, from, next) => {
  let token = $cookies.get("token");
  const path = to.path;
  const not_verifying = ['/login'];
  if (not_verifying.indexOf(path) == -1) {
    if (!token) {
      // next("/login");
      next();
    } else {
      next();
    }

  } else {
    //不需登录
    next();
  }

})

Vue.use(ElementUI);
Vue.component('icon', Icon)
//注册全局防止连续点击指令
Vue.directive('visible', visible)
Vue.directive('ld-click', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      el.style.pointerEvents = 'none';
      const delay = binding.value || 1000;
      setTimeout(() => {
        el.style.pointerEvents = 'auto';
      }, delay);
    });
  },
});
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
